import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        // 主体
        {
            path: "*",
            redirect: "/404"
        },
        {
            path: "/404",
            component: () =>
                import ("@/page/404")
        },
        {
            path: "/",
            name: "Home",
            component: () =>
                import ("@/page/Home")
        },
        {
            path: "/Optional",
            name: "Optional",
            component: () =>
                import ("@/page/Optional")
        },
        {
            path: "/IntroMarket",
            name: "IntroMarket",
            component: () =>
                import ("@/page/IntroMarket")
        },
        {
            path: "/News",
            name: "News",
            component: () =>
                import ("@/page/News")
        },
        {
            path: "/NewsEn", // 国际版
            name: "NewsEn",
            component: () =>
                import ("@/page/NewsEn")
        },
        {
            path: "/Livetv",
            name: "Livetv",
            component: () =>
                import ("@/page/Livetv")
        },
        {
            path: "/Mine",
            name: "Mine",
            component: () =>
                import ("@/page/Mine")
        },
        {
            path: "/Login",
            name: "Login",
            component: () =>
                import ("@/page/Login")
        },

        {
            path: "/Reg",
            name: "Reg",
            component: () =>
                import ("@/page/Reg")
        },
        {
            path: "/Trading",
            name: "Trading",
            component: () =>
                import ("@/page/Trading")
        },
        {
            path: "/BitcoinTrading", // 数字货币交易界面
            name: "BitcoinTrading",
            component: () =>
                import ("@/page/BitcoinTrading")
        },
        {
            path: "/Search",
            name: "Search",
            component: () =>
                import ("@/page/Search")
        },
        {
            path: "/DownloadApp",
            name: "DownloadApp",
            component: () =>
                import ("@/page/DownloadApp")
        },
        {
            path: "/Chat",
            name: "Chat",
            component: () =>
                import ("@/page/Chat")
        },
        {
            path: "/Chat2",
            name: "Chat2",
            component: () =>
                import ("@/page/Chat2")
        },

        {
            path: "/Allstock",
            name: "Allstock",
            component: () =>
                import ("@/page/Allstock")
        },

        {
            path: "/Jin10",
            name: "Jin10",
            component: () =>
                import ("@/page/Jin10")
        },

        {
            path: "/Profile/:uid",
            name: "Profile",
            component: () =>
                import ("@/page/Profile")
        },
        {
            path: "/pwdChange", //修改密码 只需要旧密码
            name: "pwdChange",
            component: () =>
                import ("@/page/pwdChange")
        },

        {
            path: "/PwdReset", // 重置密码 需要手机号
            name: "PwdReset",
            component: () =>
                import ("@/page/PwdReset")
        },

        {
            path: "/Auth",
            name: "Auth",
            component: () =>
                import ("@/page/Auth")
        },

        // 操作页 -----------------------------------------------
        {
            path: "/Strategy", // 交易排名
            name: "Strategy",
            component: () =>
                import ("@/page/Strategy")
        },
        {
            path: "/SubAccount",
            name: "SubAccount",
            component: () =>
                import ("@/view/SubAccount")
        },

        {
            path: "/UpdateSubAccount",
            name: "UpdateSubAccount",
            component: () =>
                import ("@/view/UpdateSubAccount")
        },
        {
            path: "/Subscribed", // 认购（期权）
            name: "Subscribed",
            component: () =>
                import ("@/view/Subscribed")
        },
        {
            path: "/SubscribedExtend", // 认购（互换）
            name: "SubscribedExtend",
            component: () =>
                import ("@/view/SubscribedExtend")
        },

        {
            path: "/listClientAdmin", // 客户列表
            name: "ListClientAdmin",
            component: () =>
                import ("@/view/ListClientAdmin")
        },

        {
            path: "/deposite", // 出金
            name: "Deposite",
            component: () =>
                import ("@/view/Deposite")
        },

        {
            path: "/withdraw", // 入金
            name: "Withdraw",
            component: () =>
                import ("@/view/Withdraw")
        },

        {
            path: "/SettingInOut", // 出入金设置
            name: "SettingInOut",
            component: () =>
                import ("@/view/SettingInOut")
        },
        {
            path: "/SettingNotice", // 出入金设置
            name: "SettingNotice",
            component: () =>
                import ("@/view/SettingNotice")
        },

        {
            path: "/unCheckDeposite", // 未审核出金
            name: "UnCheckDeposite",
            component: () =>
                import ("@/view/UnCheckDeposite")
        },

        {
            path: "/unCheckWithdraw", // 未审核入金
            name: "UnCheckWithdraw",
            component: () =>
                import ("@/view/UnCheckWithdraw")
        },

        {
            path: "/CustomerAction",
            name: "CustomerAction",
            component: () =>
                import ("@/view/CustomerAction")
        },
        {
            path: "/UnnormalMatch",
            name: "UnnormalMatch",
            component: () =>
                import ("@/view/UnnormalMatch")
        },

        // ------------------------------------

        {
            path: "/DelegateOrder", // 未审核入金
            name: "DelegateOrder",
            component: () =>
                import ("@/view/DelegateOrder")
        },

        {
            path: "/RecordPosition", // 未审核入金
            name: "RecordPosition",
            component: () =>
                import ("@/view/RecordPosition")
        },

        {
            path: "/RecordTrade", // 未审核入金
            name: "RecordTrade",
            component: () =>
                import ("@/view/RecordTrade")
        },

        {
            path: "/RecordStatistics", // 未审核入金
            name: "RecordStatistics",
            component: () =>
                import ("@/view/RecordStatistics")
        },

        {
            path: "/RecordCommission", // 未审核入金
            name: "RecordCommission",
            component: () =>
                import ("@/view/RecordCommission")
        },
        {
            path: "/BillDetail",
            name: "BillDetail",
            component: () =>
                import ("@/view/BillDetail")
        },

        // ----------------------------------------------

        {
            path: "/SettingRole",
            name: "SettingRole",
            component: () =>
                import ("@/view/SettingRole")
        },
        {
            path: "/SettingRolePermission/:rid/:role_name", // 改变角色的权限和菜单，管理员使用
            name: "SettingRolePermission",
            component: () =>
                import ("@/view/SettingRolePermission")
        },
        {
            path: "/SettingSubPermission/:rid/:role_name", // 改变自己子账户的权限和菜单，普通用户使用
            name: "SettingSubPermission",
            component: () =>
                import ("@/view/SettingSubPermission")
        },

        {
            path: "/SettingGroup", // 未审核入金
            name: "SettingGroup",
            component: () =>
                import ("@/view/SettingGroup")
        },
        {
            path: "/SettingMarket/:gid", // 权利金
            name: "SettingMarket",
            component: () =>
                import ("@/view/SettingMarket")
        },
        {
            path: "/SettingMarket2/:gid", // 数字货币费率
            name: "SettingMarket2",
            component: () =>
                import ("@/view/SettingMarket2")
        },

        {
            path: "/SettingRank", // 未审核入金
            name: "SettingRank",
            component: () =>
                import ("@/view/SettingRank")
        },

        {
            path: "/SettingOrg", // 未审核入金
            name: "SettingOrg",
            component: () =>
                import ("@/view/SettingOrg")
        },
        {
            path: "/orgDetail", //认购
            name: "OrgDetail",
            component: () =>
                import ("@/view/OrgDetail")
        },
        {
            path: "/SettingSystem", // 未审核入金
            name: "SettingSystem",
            component: () =>
                import ("@/view/SettingSystem")
        },
        {
            path: "/SettingCommission", // 未审核入金
            name: "SettingCommission",
            component: () =>
                import ("@/view/SettingCommission")
        },
        {
            path: "/RecordLog",
            name: "RecordLog",
            component: () =>
                import ("@/view/RecordLog")
        },

        {
            path: "/Qrcode",
            name: "Qrcode",
            component: () =>
                import ("@/view/Qrcode")
        },

        {
            path: "/element-ui",
            name: "ElementUI",
            component: () =>
                import ("@/components/ElementUI")
        },
        {
            path: "/choose",
            name: "Choose",
            component: () =>
                import ("@/components/Choose")
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js